import React, { forwardRef } from "react";
import styles from "./styles.module.css";
import { CircularProgress } from "@mui/material";
import { resolveSpinnerColor } from "./resolveSpinnerColor";

/** Global class names — use via `variant` prop or className for legacy code */
export const BUTTON_VARIANTS = {
  primary: "ubPrimaryButton",
  secondary: "ubSecondaryButton",
  tertiary: "buttonTeritary",
  delete: "ubDeleteButton",
  primaryLegacy: "buttonPrimary",
  grey: "greyButton",
  discard: "buttonDiscard",
  took: "tookButton",
  gave: "gaveButton",
};

const IconPlacements = {
  LEFT: "left",
  RIGHT: "right",
};

const UBButton = forwardRef(
  (
    {
      title = "",
      className = "",
      variant,
      iconComponent = null,
      iconRightSideComponent = null,
      iconPlacement = "left",
      titleStyle = {},
      outlined,
      loading = false,
      spinnerColor,
      ...props
    },
    ref,
  ) => {
    const variantClass = variant ? BUTTON_VARIANTS[variant] || "" : "";
    const mergedClassName = [variantClass, className].filter(Boolean).join(" ");
    const resolvedSpinnerColor = resolveSpinnerColor(mergedClassName, spinnerColor);

    return (
      <button
        type="button"
        className={`${styles.ubButtonStyle} ubButtonStyle ${mergedClassName}`.trim()}
        ref={ref}
        data-loading={loading ? "true" : undefined}
        data-variant={variant || undefined}
        {...props}
      >
        {iconPlacement === IconPlacements.LEFT && !loading ? iconComponent : null}

        <span
          className={loading ? "loaderSpan" : undefined}
          style={{
            marginLeft: iconComponent && !loading ? "5px" : "0",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flex: loading ? 1 : undefined,
            width: loading ? "100%" : undefined,
            minWidth: loading ? 0 : undefined,
            ...titleStyle,
          }}
        >
          {loading ? (
            <CircularProgress
              className={`loaderCircle ${resolvedSpinnerColor}`}
              aria-label="Loading"
            />
          ) : (
            <span>{title}</span>
          )}
        </span>

        {iconRightSideComponent ? (
          <span>{iconRightSideComponent}</span>
        ) : iconPlacement === IconPlacements.RIGHT && !loading ? (
          iconComponent
        ) : null}
      </button>
    );
  },
);

UBButton.displayName = "UBButton";

export default UBButton;
